import React, { useCallback } from 'react';
import { types } from '@guuru/chat-web';
import ChatRenderText from '../Text';
import Option from '../../Option';

interface ChatRenderVisitorRoleProps {
  message: React.ComponentProps<typeof ChatRenderText>['message'] & {
    id: string;
    metadata?: {
      roles: {
        uid: string;
        displayName: string;
      }[];
    };
  };
  // eslint-disable-next-line no-unused-vars
  dispatch?: (_: {
    type: keyof typeof types;
    processArgs: {
      uid: string;
      displayName: string;
      question: string;
    };
  }) => void;
}

const ChatRenderVisitorRole = function ({
  message,
  dispatch = () => {},
}: ChatRenderVisitorRoleProps) {
  const roles = message.metadata?.roles || [];

  const handleRoleSelection = useCallback((id: string, label: string) => {
    dispatch({
      type: types.CHAT_RUN_NEXT_STEP,
      processArgs: {
        uid: id,
        displayName: label,
        question: message.i18n,
      },
    });
  }, [dispatch, message.i18n]);

  return (
    <ChatRenderText key={message.id} message={message} tooltip={false}>
      {roles.length > 0 ? (
        <div className="message-options">
          <ul className="message-options-list">
            {roles.map((role) => (
              <Option
                key={role.uid}
                id={role.uid}
                name={role.displayName}
                onClick={handleRoleSelection}
              />
            ))}
          </ul>
        </div>
      ) : null}
    </ChatRenderText>
  );
};

export default ChatRenderVisitorRole;
